module.exports = __webpack_public_path__ + "img/1.69ff0c38.png";